import SearchableMultiSelectMenu from "@/app/components/ui/SelectMenus/MultiSelectMenu";
import { useSelectMenuReducer } from "@/app/hooks/useSelectMenuReducer";
import { Dialog, Transition } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { Fragment, useEffect, useRef } from "react";
import { useForm } from "react-hook-form";

interface IUploadLabReportModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  handelAddLabPartner: (item: any) => void;
  clinicId: string | null;
  labPartners: any;
  labList: any;
}

const LabClinicModalComponent: React.FC<IUploadLabReportModalProps> = ({
  open,
  setOpen,
  clinicId,
  labPartners,
  labList,
  handelAddLabPartner,
}) => {
  const cancelButtonRef = useRef(null);

  const formHook = useForm<any>({
    mode: "onChange",
    defaultValues: {
      clinic_lab_mapping: [],
    },
  });

  // useEffect(() => {
  //   if (labPartners?.length > 0) {
  //     formHook.setValue(
  //       "clinic_lab_mapping",
  //       labPartners.map((item) => item.lab_id),
  //     );
  //   }
  // }, [labPartners]);

  const labPartnersItems = useSelectMenuReducer(labList, "display_name", "lab_id");

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="fixed inset-0 z-50 overflow-y-auto"
        initialFocus={cancelButtonRef}
        onClose={() => setOpen(true)}
      >
        <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>
          <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
            &#8203;
          </span>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enterTo="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <div className="inline-block align-bottom bg-white rounded-lg text-left  shadow-xl transform transition-all sm:my-8 sm:align-middle w-full sm:max-w-xl 2xl:max-w-xl">
              <div className="bg-white px-4 pt-1  rounded-xl mt-5">
                <div className="mb-4 flex justify-between items-center">
                  <p className="font-semibold text-sm">Lab Partner Maping</p>
                  <XMarkIcon className="w-5 h-5 cursor-pointer" onClick={() => setOpen(false)} />
                </div>
                <div className="">
                  <SearchableMultiSelectMenu
                    withSelectAll
                    errorMessages={[{ type: "required", message: "" }]}
                    onSelectItem={(item) => {
                      if (item) {
                        const statusId = item.map((i) => i.id);
                        formHook.setValue("clinic_lab_mapping", statusId);
                      }
                    }}
                    fieldError={formHook.formState.errors.clinic_lab_mapping}
                    register={formHook.register("clinic_lab_mapping", { required: true })}
                    selectItems={labPartnersItems}
                    placeholder="Select Lab"
                    showTooltips={false}
                    showTypedErrors={false}
                    showDropdownIcon={true}
                    withDropDownSearch
                    defaultSelected={labPartnersItems?.filter((c) =>
                      formHook.watch("clinic_lab_mapping")?.includes(c.id),
                    )}
                    listBoxClassName="w-full"
                    className="text-gray-800"
                    containerClassName="w-full"
                  />
                </div>
                <button
                  disabled={formHook.watch("clinic_lab_mapping")?.length === 0}
                  className={`text-xs text-white bg-black float-right my-5 p-2 rounded-md font-medium  ${formHook.watch("clinic_lab_mapping")?.length === 0 && "bg-gray-400"}`}
                  onClick={() => handelAddLabPartner(formHook.watch("clinic_lab_mapping"))}
                >
                  Add Lab Partners
                </button>
              </div>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default LabClinicModalComponent;
